import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';

import styles from './jtn-ui-textarea.styles.scss?module';

interface Events {
  onInput: { target: HTMLInputElement };
}

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiTextarea',
    props: {
      id: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      maxLength: {
        type: Number,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      hasError: {
        type: Boolean,
        default: false
      },
      resize: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        textareaValue: this.value
      };
    },
    computed: {
      textLength(): number {
        return this.value.length;
      }
    },
    watch: {
      value() {
        this.textareaValue = this.value;
      }
    },
    render() {
      const attributes = {
        attrs: this.$attrs
      };

      return (
        <div>
          <label for={this.id} class={styles.label}>
            <span class={styles.labelText}>
              {this.label}
              {this.required ? <span class={styles.requiredMark}>{' *'}</span> : null}
            </span>
            {this.maxLength !== null ? (
              <span class={styles.textareaCounter}>
                <span>{this.textLength}</span>
                {` / ${this.maxLength}`}
              </span>
            ) : null}
          </label>
          <textarea
            value={this.textareaValue}
            id={this.id}
            class={[
              styles.textarea,
              this.hasError ? styles.textareaError : '',
              this.resize ? '' : styles.noResize
            ]}
            required={this.required}
            maxlength={this.maxLength}
            onInput={event => this.$emit('input', event)}
            {...attributes}
          />
          <div class={styles.error}>{this.$slots.error}</div>
        </div>
      );
    }
  });
